// extracted by mini-css-extract-plugin
module.exports = {"BottomOptions":"Login_BottomOptions__30BKX","Title":"Login_Title__ZlEBE"};